import { SystemUser } from './system-user';

export class LanguageCourse {

    constructor(
        public code: string,
        public descriptionFr: string,
        public descriptionEn: string,
        public descriptionNl: string,
        public descriptionEs: string,
        public descriptionPt: string,
        public created?: Date,
        public createdBy?: SystemUser,
        public id?: number,
        public customLabel?: string | null
    ){}
}
